"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicCompanyProfilePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const elements_1 = require("@src/components/elements");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const styled_components_1 = __importDefault(require("styled-components"));
const Company_1 = require("./Company");
const company_profile_1 = __importDefault(require("../admin/modules/company-profile"));
const PublicCompanyProfilePage = () => {
    const [subscribersCount, setSubscribersCount] = react_1.default.useState();
    const params = (0, react_router_1.useParams)();
    const history = (0, react_router_1.useHistory)();
    const { data: company, error, isLoading, } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.companyProfile.key, params.companyUniqueUrl, [
        subscribersCount,
        params.companyUniqueUrl,
    ]);
    react_1.default.useEffect(() => {
        if (error) {
            history.pushLocalized('/error');
        }
    }, [error]);
    react_1.default.useEffect(() => {
        var _a, _b;
        if (((_a = company === null || company === void 0 ? void 0 : company.subscribers) === null || _a === void 0 ? void 0 : _a.length) !== subscribersCount) {
            setSubscribersCount((_b = company === null || company === void 0 ? void 0 : company.subscribers) === null || _b === void 0 ? void 0 : _b.length);
        }
    }, [company]);
    if (isLoading || !company) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "width-100 flex-row justify-center", children: (0, jsx_runtime_1.jsx)(CustomSpinner, {}) }));
    }
    if (company.companyPremiumSettings && company.companyPremiumSettings.hasPremiumProfileEnabled) {
        return (0, jsx_runtime_1.jsx)(company_profile_1.default, { company: company });
    }
    return (0, jsx_runtime_1.jsx)(Company_1.CompanyPage, { company: company, subscribersCount: subscribersCount });
};
exports.PublicCompanyProfilePage = PublicCompanyProfilePage;
const CustomSpinner = (0, styled_components_1.default)(elements_1.Spinner) `
	align-items: center;
	height: 500px;
	display: flex;
	justify-content: center;

	.ant-spin-dot {
		font-size: 5rem;
	}
`;
